import cloneDeep from 'lodash/cloneDeep'
import dayjs from 'dayjs'
import { LOCALSTORAGE_KEYS } from '@features/General'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ListTaskAction } from '@typings/requestPayloads'

const { onRequest, onSuccess, onFailure } = rootActions.events.searchEvents

function* searchEventsSagaTask({ payload }: ListTaskAction) {
    try {
        const params: any = {
            ...payload.pagination,
            query: payload.query
        }
        const response = yield axios.get(`/search/events`, {
            params
        })
        if (response.success) {
            const priorities = { VIP: 1, High: 2, Normal: 3, Low: 4, undefined: 5 }
            const data = cloneDeep(
                response.result.data.sort((a, b) => {
                    if (priorities[a.priority] == priorities[b.priority] && (a.ordering || 0) === (b.ordering || 0)) {
                        return dayjs(b.timestamps?.[0]?.startDate, 'YYYY-MM-DD hh:mm AZ').isAfter(
                            dayjs(a.timestamps?.[0]?.startDate, 'YYYY-MM-DD hh:mm AZ')
                        )
                            ? 1
                            : -1
                    } else if (priorities[a.priority] == priorities[b.priority]) {
                        return priorities[a.priority] + (b.ordering || 0) - priorities[b.priority] + (a.ordering || 0)
                    } else {
                        return priorities[a.priority] - priorities[b.priority]
                    }
                })
            )
            yield put(onSuccess({ ...response.result, data }))
            if (typeof payload?.sagaCB?.onSuccess === 'function')
                payload?.sagaCB?.onSuccess({ ...response.result, data })
            localStorage.setItem(LOCALSTORAGE_KEYS.EVENT_LIST, JSON.stringify(data))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* searchEventsSaga(): any {
    yield takeLatest<ListTaskAction>(onRequest, searchEventsSagaTask)
}

export default searchEventsSaga
